import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { provisioningService } from '../../services/provisioningServices';
import './CallBack.scss';

const CallBack = () => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [hasRun, setHasRun] = useState(false);

  useEffect(() => {
    if (hasRun) return;
    
    const authenticate = async () => {
      setHasRun(true);
      
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        
        if (!code) {
          throw new Error('No authorization code found');
        }

        if (sessionStorage.getItem('isLoggedIn') === 'true') {
          history.replace('/plant-monitoring/dashboard');
          return;
        }

        const tokenData = await provisioningService.exchangeCodeForToken(code, state);
        
        sessionStorage.setItem('access_token', tokenData.access_token);
        sessionStorage.setItem('isLoggedIn', 'true');
        
        if (tokenData.refresh_token) {
          sessionStorage.setItem('refresh_token', tokenData.refresh_token);
        }
        if (tokenData.id_token) {
          sessionStorage.setItem('id_token', tokenData.id_token);
        }
        
        history.replace('/plant-monitoring/dashboard');
        
      } catch (err) {
        console.error('Authentication error:', err);
        sessionStorage.removeItem('isLoggedIn');
        setError(err.message || 'Failed to authenticate');
      }
    };

    authenticate();
  }, [history, hasRun]); 

  if (error) {
    return (
      <div className="callback-container error">
        <h2>Authentication Failed</h2>
        <p>{error}</p>
        <button onClick={() => {
          sessionStorage.clear();
          window.location.href = '/login';
        }}>
          Return to Login
        </button>
      </div>
    );
  }

  // return (
  //   <div className="callback-container">
  //     <div className="spinner"></div>
  //     <p>Completing authentication...</p>
  //   </div>
  // );
};

export default CallBack;